import { render, staticRenderFns } from "./properties-block-menu.vue?vue&type=template&id=e1403168&scoped=true"
import script from "./properties-block-menu.vue?vue&type=script&lang=js"
export * from "./properties-block-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1403168",
  null
  
)

export default component.exports